import $ from 'jquery';
import { Formatter, PaymentCalculatorFactory } from '@dealersites/dealersite-js-core';
import { formatPrice } from '@oem-theme/utilities.js';
import { getTotalIMSTargetedSelected } from '../showroom/showroom-utilities.js'

const $site = $('.site');

let FREQUENCY = $site.data('frequency');
let STANDARD_FREQUENCY = $site.data('standard-frequency');

const validFrequencies = ['weekly', 'biweekly', 'monthly'];

if (!validFrequencies.includes(FREQUENCY)) {
  FREQUENCY = "biweekly";
}

class PaymentCalculatorForm {

  constructor(formElementId, tags = []) {

    this.formatVdpPrice = formatPrice.custom(['calculator-form', ...tags]);

    this.element = document.getElementById(formElementId + 'form');
    this.targetIncentives = document.getElementById('targeted-incentives');
    if (!this.element) {
      return;
    }

    this.prefix = '#' + formElementId;

    this.finance = PaymentCalculatorFactory.createCalculator('finance', {frequency: FREQUENCY});
    this.lease = PaymentCalculatorFactory.createCalculator('lease', {frequency: FREQUENCY});

    this.hasFinanceCalculator = true;
    this.hasLeaseCalculator = true;

    this.hasPaymentDropdown = false;

    let financeVariables = $(this.prefix + 'finance-balance-value').data('finance-values');

    this.financeVariables = [];

    if (financeVariables) {
      for (const [key, value] of Object.entries(financeVariables)) {
        this.financeVariables.push(value);
      }
    }

    this.leaseVariables = [];

    let leaseVariables = $(this.prefix + 'lease-balance-value').data('lease-values');

    if (leaseVariables) {
      for (const [key, value] of Object.entries(leaseVariables)) {
        this.leaseVariables.push(value);
      }
    }

    this.includeTax = true;

    this.dropdown = this.element.querySelector(this.prefix + 'payment-dropdown');

    if (this.dropdown) {
      this.hasPaymentDropdown = true;
    }

    $('.payment-frequency-select').on('click', function () {
      $('.payment-frequency-select').removeClass('active');
      $(this).addClass('active');
    });

    $(`#${formElementId}form`).find('.js-targeted-incentive').on("change", (e) => {
      e.preventDefault();
      this.calculate();
    });

    // Store reference
    this.productElements = {
      tax: this.element.querySelector(this.prefix + 'tax'),
      tradein: this.element.querySelector(this.prefix + 'tradein'),
      has_tax: this.element.querySelector(this.prefix + 'include-taxes'),
      payment_frequency: this.element.querySelector(this.prefix + 'payment-frequency-buttons'),
    };

    // Store reference
    this.financeElements = {
      name: 'Finance Data',
      price: this.element.querySelector(this.prefix + 'price'),
      down: this.element.querySelector(this.prefix + 'finance-down'),
      term: this.element.querySelector(this.prefix + 'finance-term'),
      rate: this.element.querySelector(this.prefix + 'finance-rate'),
      balance: this.element.querySelectorAll(this.prefix + 'finance-balance'),
      payment: this.element.querySelector(this.prefix + 'finance-payment'),
      payment_frequency: this.element.querySelector(this.prefix + 'finance-frequency-payment'),
      costOfBorrowing: this.element.querySelector(this.prefix + 'finance-cob') ?? false,
    };

    for (const prop in this.financeElements) {
      if (this.financeElements[prop] === null) {
        this.hasFinanceCalculator = false;
      }
    }

    // for (const product in this.productElements) {
    //   console.log(this.productElements[product]);
    // }

    // for (const product in this.financeElements) {
    //   console.log(this.financeElements[product]);
    // }

    // Store reference
    this.leaseElements = {
      name: 'Lease Data',
      price: this.element.querySelector(this.prefix + 'lease-price'),
      down: this.element.querySelector(this.prefix + 'lease-down'),
      term: this.element.querySelector(this.prefix + 'lease-term'),
      rate: this.element.querySelector(this.prefix + 'lease-rate'),
      end: this.element.querySelector(this.prefix + 'lease-end'),
      balance: this.element.querySelectorAll(this.prefix + 'lease-balance'),
      payment: this.element.querySelector(this.prefix + 'lease-payment'),
      payment_frequency: this.element.querySelector(this.prefix + 'lease-frequency-payment'),
      costOfBorrowing: this.element.querySelector(this.prefix + 'lease-cob') ?? false,
      mileage: this.element.querySelector(this.prefix + 'lease-mileage') ?? false,
    };

    for (const prop in this.leaseElements) {
      if (this.leaseElements[prop] === null) {
        this.hasLeaseCalculator = false;
      }
    }
    

  

    // Handle the "Submit" (calculate) button
    this.element.addEventListener('submit', (event) => {
      event.preventDefault();
      this.calculate();
    });

    // Handle the frequency changing.
    this.productElements.payment_frequency.addEventListener('change', (event) => {
      let frequency = event.target.value;

      if (!validFrequencies.includes(frequency)) {
        frequency = "biweekly";
      }

      let label = ` / ${STANDARD_FREQUENCY[frequency]}`

      if (this.financeElements.payment_frequency) {
        this.financeElements.payment_frequency.innerHTML = label;
      }
      if (this.leaseElements.payment_frequency) {
        this.leaseElements.payment_frequency.innerHTML = label;
      }

      this.finance.frequency = frequency;
      this.lease.frequency = frequency;

      this.calculate();
    });

    this.financeDownDisplay = false;
    this.leaseDownDisplay = false;

    if (this.hasFinanceCalculator) {
      this.financeDownDisplay = this.element.querySelectorAll('.js-summary-down-payment.finance');
    }

    if (this.hasLeaseCalculator) {
      this.leaseDownDisplay = this.element.querySelectorAll('.js-summary-down-payment.lease');
    }

    //added
    if (this.financeElements.down) {
      this.financeElements.down.addEventListener('input', () => {
        let downAmount = parseInt(this.financeElements.down.value);
        if (this.financeDownDisplay) {
          this.financeDownDisplay.forEach((elem) => {
           $(elem).text('- ' + this.formatVdpPrice(downAmount));
          })
        }
        this.calculate();
      });
    }
    //added
    if (this.leaseElements.down) {
      this.leaseElements.down.addEventListener('input', () => {
        let downAmount = parseInt(this.leaseElements.down.value);
        if (this.leaseDownDisplay) {
          this.leaseDownDisplay.forEach((elem) => {
            $(elem).text('- ' + this.formatVdpPrice(downAmount));
          })
        }
        this.calculate();
      });
    }

    if (this.financeElements.term && this.financeVariables) {
      this.financeElements.term.addEventListener('change', () => {
        const term = this.financeElements.term.value;

        let financeTerms = this.financeVariables.filter((obj) => {
          return obj.to == term;
        });
        const rate = financeTerms[0].value;

        this.financeElements.rate.innerHTML = parseFloat(rate).toFixed(2);

        this.calculate();
        // incentive accordion
        this.nasapiLeaseIncentiveUpdate(term, 'finance');
      });
    }

    if (this.leaseElements.term && this.leaseVariables) {
      this.leaseElements.term.addEventListener('change', () => {
        const term = this.leaseElements.term.value;

        let leaseTerms = this.leaseVariables.filter((obj) => {
          return obj.to == term;
        });

        // get new values for the term

        // each term carries its own kilometre options
        this.updateLeaseMileageOptions(leaseTerms[0]);

        const leasePrice = leaseTerms[0].incentive_price;
        const rate = leaseTerms[0].value;

        // updates inputs with the new values for the term
        this.leaseElements.end.value = this.selectedLeaseResidual(leaseTerms[0]);
        this.leaseElements.price.value = leasePrice;
        this.leaseElements.rate.innerHTML = parseFloat(rate).toFixed(2);

        this.calculate();

        // incentive accordion
        this.nasapiLeaseIncentiveUpdate(term, 'lease');
      });
    }

    // detect change to mileage
    if (this.leaseElements.mileage) {
      this.leaseElements.mileage.addEventListener('change', () => {
        const leaseTerm = this.leaseTermFor(this.leaseElements.term.value);
        this.leaseElements.end.value = this.selectedLeaseResidual(leaseTerm);
        this.calculate();
      });
    }

    //end added

    // Init with calculations already run once
    this.calculate();
  }

  /**
   * Update calculators with current values.
   */
  updateCalculators() {

    let tradein = this.productElements.tradein.value
      ? Formatter.number(this.productElements.tradein.value)
      : 0;
    let tax = this.includeTax ? Formatter.number(this.productElements.tax.value) : 0;

    if (this.hasFinanceCalculator) {
      // Update Finance Calculator
      Object.assign(this.finance, {
        price: this.financeElements.price.value
          ? Formatter.number(this.financeElements.price.value) - getTotalIMSTargetedSelected('finance')
          : 0,
        tradein,
        tax,
        down: this.financeElements.down.value
          ? Formatter.number(this.financeElements.down.value)
          : 0,
        term: this.financeElements.term.value
          ? Formatter.integer(this.financeElements.term.value)
          : 0,
        rate: this.financeElements.rate.innerHTML
          ? Formatter.number(this.financeElements.rate.innerHTML)
          : 0,  
      });
    
    }
    // Update Lease Calculator
    if (this.hasLeaseCalculator) {
      Object.assign(this.lease, {
        price: this.leaseElements.price.value
          ? Formatter.number(this.leaseElements.price.value) - getTotalIMSTargetedSelected('lease')
          : 0,
        tradein,
        tax,
        down: this.leaseElements.down.value ? Formatter.number(this.leaseElements.down.value) : 0,
        term: this.leaseElements.term.value ? Formatter.integer(this.leaseElements.term.value) : 0,
        rate: this.leaseElements.rate.innerHTML
          ? Formatter.number(this.leaseElements.rate.innerHTML)
          : 0, 
        residual: this.leaseElements.end.value ? Formatter.number(this.leaseElements.end.value) : 0,
      });
    }
  }

  calculate() {
    this.updateCalculators();
    let paymentFrequency = FREQUENCY;

    $('.payment-frequency-button').each(function () {
      if ($(this)[0].checked) {
        paymentFrequency = $(this)[0].value;
      }
    });

    if (this.hasPaymentDropdown) {
      paymentFrequency = this.dropdown.querySelector('option:checked').value;
    }

    if (this.hasFinanceCalculator) {
      this.finance.calculate();

      this.financeElements.balance.forEach((elem) => {
        elem.textContent = isFinite(this.finance.balance)
        ? this.formatVdpPrice(this.finance.balance)
        : '$--.--';
      })

      if (this.financeElements.costOfBorrowing) {
        this.financeElements.costOfBorrowing.textContent = isFinite(this.finance.costOfBorrowing)
          ? this.formatVdpPrice(this.finance.costOfBorrowing)
          : '$--.--';
      }

      // console.log('FINANCE PAYMENT STRUCTURE: ', this.finance.payments);

      this.financeElements.payment.textContent = isFinite(this.finance.payments)
        ? this.formatVdpPrice(this.finance.payments)
        : '$--.--';
    }

    if (this.hasLeaseCalculator) {
      this.lease.calculate();

      this.leaseElements.balance.forEach((elem) => {
        elem.textContent = isFinite(this.lease.balance)
        ? this.formatVdpPrice(this.lease.balance)
        : '$--.--';
      })

      if (this.leaseElements.costOfBorrowing) {
        this.leaseElements.costOfBorrowing.textContent = isFinite(this.lease.costOfBorrowing)
          ? this.formatVdpPrice(this.lease.costOfBorrowing)
          : '$--.--';
      }

      this.leaseElements.payment.textContent = isFinite(this.lease.payments)
        ? this.formatVdpPrice(this.lease.payments)
        : '$--.--';
    }
  }

  // Accordion
  nasapiLeaseIncentiveUpdate(term, type) {
    const $nasapiTermIncentives = $(`.js-nasapi-${type}-incentives`);
    $nasapiTermIncentives.each(function () {
      $(this).addClass('hidden');
      const nasapiTerm = $(this).data('term');
      if (nasapiTerm == term) {
        $(this).removeClass('hidden');
      }
    });
  }

    leaseTermFor(term) {
    return this.leaseVariables.find((obj) => obj.to == term);
  }

  // looks at lease term given (specifically it's mileage) and provides residual value based on the mileage
  selectedLeaseResidual(leaseTerm) {
    const options = leaseTerm?.mileage_options ?? [];
    const selected = options.find((o) => String(o.mileage) === this.leaseElements.mileage?.value);
    return selected ? selected.residual_value : leaseTerm.residual_value;
  }

  // Rebuild the kilometre options for a term, keeping the shopper's choice
  // when the new term still offers it.
  updateLeaseMileageOptions(leaseTerm) {
    const select = this.leaseElements.mileage;
    if (!select) return;

    const options = leaseTerm?.mileage_options ?? [];
    const previous = select.value;

    select.closest('.terms-wrapper').classList.toggle('hidden', options.length < 2);
    select.innerHTML = '';

    options.forEach((option) => {
      const el = document.createElement('option');
      el.value = option.mileage;
      el.dataset.residual = option.residual_value;
      el.textContent = Number(option.mileage).toLocaleString();
      select.appendChild(el);
    });

    const match = options.find((o) => String(o.mileage) === previous);
    select.value = String((match ?? options[0])?.mileage ?? '');
  }
}

export default PaymentCalculatorForm;
